// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__Bmfkd","menu":"Dropdown_menu__iPZNb","text":"Dropdown_text__rmciN"};